import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import styled, { css } from "styled-components";

interface OwnProps {

}
type XcHorizontalRuleProps = OwnProps;

interface XcHorizontalRuleStyles {
    wrapper?: InjectableCss;
    hrule?: InjectableCss;
}

const xcHorizontalRuleStyles: XcHorizontalRuleStyles = {
    wrapper: {
        css: css`
            width: 100%;
            padding: 0 10px;
            display: flex;
            flex-direction: row;
            justify-content: center;
        `,
    },
    hrule: {
        css: css`
            border-bottom: 1px solid #cccccc;
            width: 100%;
        `,
    },
}

const styles = xcHorizontalRuleStyles;

const HR = styled.hr`
    
`;

const XcHorizontalRule = (props: XcHorizontalRuleProps) => {
    return (
        <StyledWrapper {...styles.wrapper}>
            <StyledWrapper {...styles.hrule}>
                
            </StyledWrapper>
        </StyledWrapper>
    )
}

export default XcHorizontalRule;
